// extracted by mini-css-extract-plugin
export default {"SystemMessageContainer":"SystemMessage_SystemMessageContainer__03ckj"};